/* Persona gift: auto-add the $0 FREE Bamboo Bar Holder when the cart carries the
   "Free Bamboo Holder" entitlement in _offer. Mirrors cust-persona-rebuy-freeship.js patterns. */
(function () {
  'use strict';
  var GIFT_VARIANT = 39666046009443;
  var busy = false, retried = false;
  function offers(cart) {
    var raw = cart.attributes && (cart.attributes._offer || cart.attributes['_offer'] || '');
    if (!raw) return '';
    try { var j = JSON.parse(raw); return Array.isArray(j) ? j.join(',') : String(raw); }
    catch (e) { return String(raw); }
  }
  function refresh() {
    try { if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.refresh === 'function') Rebuy.SmartCart.refresh(); } catch (e) {}
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
  function check() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var entitled = offers(cart).indexOf('Free Bamboo Holder') !== -1;
      var giftLine = null, paid = 0;
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._offer_gift === 'bamboo') giftLine = it;
        else if (it.id !== GIFT_VARIANT) paid++;
      });
      if (entitled && paid > 0 && !giftLine) {
        return post('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _offer_gift: 'bamboo' } }] })
          .then(function (r) {
            if (!r.ok && !retried) { retried = true; return new Promise(function (res) { setTimeout(res, 1500); }).then(check); }
            refresh();
          });
      }
      if (giftLine && (!entitled || paid === 0)) {
        return post('/cart/change.js', { id: giftLine.key, quantity: 0 }).then(refresh);
      }
    }).catch(function () {}).then(function () { busy = false; });
  }
  document.addEventListener('rebuy:smartcart.init', check);
  document.addEventListener('rebuy:cart.change', check);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 600); });
  } else { setTimeout(check, 600); }
})();
